import sha256 from 'crypto-js/sha256';

export async function sha256Encrypt(message) {
    const hash = sha256(message);
    return hash.toString();
}